document.addEventListener('DOMContentLoaded', () => {

    const widget = document.querySelector('.free-gift-widget');
    const modal = document.querySelector('.free-gift-modal');

    if (!widget || !modal) return;

    const mediaWrapper = document.querySelector('.product__media-wrapper');

    if (mediaWrapper) {
        mediaWrapper.style.position = 'relative';
    }

    const overlay  = modal.querySelector('.free-gift-modal__overlay');
    const closeBtn = modal.querySelector('.free-gift-modal__close');
    const confirmBtn = modal.querySelector('.free-gift-confirm');

    const orbitLabel = document.querySelector('.free-gift-orbit-label');
    const widgetImage = document.querySelector('.free-gift-widget__image');

    let userHasSelected = false;

    /*
    Snapshot of which variant value was checked when the modal opened.
    We compare this on confirm/close to decide whether the user actually
    made a NEW selection — fireworks only fire if they changed something.
    */
    let selectionOnOpen = null;

    function getCheckedVariantValue() {
        const checked = document.querySelector('input[name="free_gift_variant"]:checked');
        return checked ? checked.value : null;
    }

    /*
    ==================================
    Fireworks Engine
    ==================================
    */

    (function () {

        const canvas = document.createElement('canvas');

        canvas.style.cssText = `
            position: fixed;
            inset: 0;
            width: 100vw;
            height: 100vh;
            pointer-events: none;
            z-index: 999999;
            display: none;
        `;

        document.body.appendChild(canvas);

        const ctx = canvas.getContext('2d');

        let W, H, rafId, particles, rockets, startTime;

        const COLORS = [
            '#FF5E5E', '#FF9F40', '#FFD43B', '#51CF66',
            '#339AF0', '#CC5DE8', '#FF6FB7', '#FFB347',
            '#74C0FC', '#F783AC', '#FFFFFF', '#FFD700'
        ];

        function resize() {
            W = canvas.width  = window.innerWidth;
            H = canvas.height = window.innerHeight;
        }

        window.addEventListener('resize', resize);

        function rand(a, b) { return a + Math.random() * (b - a); }

        function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

        function hex(alpha) {
            return Math.floor(Math.max(0, Math.min(1, alpha)) * 255)
                .toString(16)
                .padStart(2, '0');
        }

        class Particle {
            constructor(x, y, color, angle, speed, life) {
                this.x = x; this.y = y;
                this.color = color;
                this.vx = Math.cos(angle) * speed;
                this.vy = Math.sin(angle) * speed;
                this.life = life;
                this.maxLife = life;
                this.size = rand(2.5, 5);
                this.trail = [];
            }
            update() {
                this.trail.push({ x: this.x, y: this.y });
                if (this.trail.length > 6) this.trail.shift();
                this.vx *= 0.97;
                this.vy *= 0.97;
                this.vy += 0.08;
                this.x += this.vx;
                this.y += this.vy;
                this.life--;
            }
            draw() {
                const alpha = this.life / this.maxLife;
                for (let i = 0; i < this.trail.length; i++) {
                    const t = this.trail[i];
                    const ta = (i / this.trail.length) * alpha * 0.4;
                    ctx.beginPath();
                    ctx.arc(t.x, t.y, this.size * 0.5, 0, Math.PI * 2);
                    ctx.fillStyle = this.color + hex(ta);
                    ctx.fill();
                }
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size * alpha, 0, Math.PI * 2);
                ctx.fillStyle = this.color + hex(alpha);
                ctx.fill();
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size * alpha * 0.5, 0, Math.PI * 2);
                ctx.fillStyle = '#ffffff' + hex(alpha * 0.8);
                ctx.fill();
            }
        }

        class Rocket {
            constructor(ox, oy, tx, ty) {
                this.x = ox; this.y = oy;
                this.tx = tx; this.ty = ty;
                const dx = tx - ox;
                const dy = ty - oy;
                const dist = Math.sqrt(dx * dx + dy * dy);
                const speed = rand(12, 20);
                this.vx = (dx / dist) * speed;
                this.vy = (dy / dist) * speed;
                this.color = pick(COLORS);
                this.trail = [];
                this.exploded = false;
            }
            update() {
                this.trail.push({ x: this.x, y: this.y });
                if (this.trail.length > 10) this.trail.shift();
                this.x += this.vx;
                this.y += this.vy;
                this.vy += 0.05;
                const dx = this.tx - this.x;
                const dy = this.ty - this.y;
                if (Math.sqrt(dx * dx + dy * dy) < 20 || this.y < this.ty) {
                    this.explode();
                    this.exploded = true;
                }
            }
            explode() {
                const count = Math.floor(rand(90, 140));
                const c2 = pick(COLORS);
                for (let i = 0; i < count; i++) {
                    const angle = (i / count) * Math.PI * 2;
                    const speed = rand(3, 10);
                    const life  = Math.floor(rand(55, 90));
                    particles.push(new Particle(
                        this.x, this.y,
                        Math.random() > 0.3 ? this.color : c2,
                        angle, speed, life
                    ));
                }
                for (let i = 0; i < 15; i++) {
                    particles.push(new Particle(
                        this.x, this.y, '#FFD700',
                        rand(0, Math.PI * 2),
                        rand(10, 18),
                        Math.floor(rand(30, 50))
                    ));
                }
            }
            draw() {
                for (let i = 0; i < this.trail.length; i++) {
                    const t = this.trail[i];
                    const a = (i / this.trail.length) * 0.8;
                    ctx.beginPath();
                    ctx.arc(t.x, t.y, 2.5 * a, 0, Math.PI * 2);
                    ctx.fillStyle = this.color + hex(a);
                    ctx.fill();
                }
                ctx.beginPath();
                ctx.arc(this.x, this.y, 3, 0, Math.PI * 2);
                ctx.fillStyle = '#ffffff';
                ctx.fill();
            }
        }

        function loop(ts) {
            if (!startTime) startTime = ts;
            const elapsed = ts - startTime;

            ctx.clearRect(0, 0, W, H);

            rockets = rockets.filter(r => {
                r.update();
                r.draw();
                return !r.exploded;
            });

            particles = particles.filter(p => {
                p.update();
                p.draw();
                return p.life > 0;
            });

            if (elapsed < 2400 || rockets.length > 0 || particles.length > 0) {
                rafId = requestAnimationFrame(loop);
            } else {
                ctx.clearRect(0, 0, W, H);
                canvas.style.display = 'none';
            }
        }

        window.launchFireworks = function (originEl) {

            resize();

            const rect = originEl.getBoundingClientRect();
            const ox = rect.left + rect.width  / 2;
            const oy = rect.top  + rect.height / 2;

            particles = [];
            rockets   = [];
            startTime = null;

            cancelAnimationFrame(rafId);

            canvas.style.display = 'block';

            /* Wave 1 — burst from origin across 5 screen zones */
            const zones = [
                [W * 0.05, W * 0.35, H * 0.05, H * 0.45],
                [W * 0.25, W * 0.65, H * 0.05, H * 0.40],
                [W * 0.55, W * 0.95, H * 0.05, H * 0.45],
                [W * 0.05, W * 0.35, H * 0.40, H * 0.75],
                [W * 0.55, W * 0.95, H * 0.40, H * 0.75],
            ];

            zones.forEach((z, i) => {
                setTimeout(() => {
                    rockets.push(new Rocket(
                        ox, oy,
                        rand(z[0], z[1]),
                        rand(z[2], z[3])
                    ));
                }, i * 80 + rand(0, 60));
            });

            /* Wave 2 — rise from bottom */
            setTimeout(() => {
                for (let i = 0; i < 5; i++) {
                    setTimeout(() => {
                        rockets.push(new Rocket(
                            rand(W * 0.3, W * 0.7), H,
                            rand(W * 0.1, W * 0.9),
                            rand(H * 0.05, H * 0.6)
                        ));
                    }, i * 120);
                }
            }, 400);

            /* Wave 3 — finale */
            setTimeout(() => {
                for (let i = 0; i < 4; i++) {
                    setTimeout(() => {
                        rockets.push(new Rocket(
                            rand(W * 0.2, W * 0.8), H,
                            rand(W * 0.1, W * 0.9),
                            rand(H * 0.05, H * 0.5)
                        ));
                    }, i * 100);
                }
            }, 800);

            rafId = requestAnimationFrame(loop);
        };

    })();

    /*
    ==================================
    Modal Functions
    ==================================
    */

    function openModal() {
        // Snapshot the current selection so we can detect a real change later
        selectionOnOpen = getCheckedVariantValue();
        modal.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
        /* Pause the orbit spin while the gift-picker modal is open */
        const orbitSvg = document.querySelector('.free-gift-widget__orbit-svg');
        if (orbitSvg) orbitSvg.style.animationPlayState = 'paused';
    }

    function closeModal() {
        modal.classList.add('hidden');
        document.body.style.overflow = '';
        /* Resume orbit spin */
        const orbitSvg = document.querySelector('.free-gift-widget__orbit-svg');
        if (orbitSvg) orbitSvg.style.animationPlayState = 'running';
    }

    widget.addEventListener('click', openModal);

    /*
    Overlay click — only close, no fireworks
    (user dismissed without confirming)
    */
    overlay.addEventListener('click', closeModal);

    /*
    Close button — fire fireworks only if the user actively changed
    their selection during this modal session (i.e. picked something
    different from what was checked when they opened it).
    Just viewing and closing without changing = no fireworks.
    */
    closeBtn.addEventListener('click', () => {

        const currentSelection = getCheckedVariantValue();
        const selectionChanged = currentSelection !== selectionOnOpen;

        closeModal();

        if (selectionChanged && currentSelection !== null) {
            userHasSelected = true;
            updateWidget();
            launchFireworks(widget);
        }

    });

    /*
    ==================================
    Update Customer Note
    ==================================
    */

    function updateFreeGiftNote(giftName, giftQty) {

        const noteField = document.querySelector('#_rsi-field-note');

        if (!noteField) return;

        let currentNote = noteField.value || '';

        /* Always strip any existing gift annotation first */
        currentNote = currentNote
            .replace(/\s*🎁 Free Gift:.*$/g, '')
            .trim();

        /* Only append if we have a gift name */
        if (giftName) {
            const qtyPart = (giftQty && giftQty > 1) ? ` x${giftQty}` : '';
            noteField.value = (
                currentNote + ` 🎁 Free Gift: ${giftName}${qtyPart}`
            ).trim();
        } else {
            noteField.value = currentNote;
        }

        noteField.dispatchEvent(new Event('input',  { bubbles: true }));
        noteField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /*
    ==================================
    Update Widget
    ==================================
    */

    function updateWidget() {

        const selected = document.querySelector(
            'input[name="free_gift_variant"]:checked'
        );

        if (!selected) return;

        const title = selected.dataset.title;
        const image = selected.dataset.image;

        /* Update orbit text only after user confirms */
        if (orbitLabel && userHasSelected) {
            const isSingleGift = document.querySelectorAll(
                'input[name="free_gift_variant"]'
            ).length === 1;

            const displayLabel = isSingleGift ? 'FREE GIFT' : title;
            orbitLabel.textContent = `${displayLabel} ✦ ${displayLabel} ✦ ${displayLabel} ✦ `;
        }

        /* Update widget image */
        if (image && widgetImage) {
            widgetImage.src = image;
        }

        /* Save selection */
        localStorage.setItem('selectedFreeGiftVariant', selected.value);

        /* Resolve quantity for the note (using the shared helper if available) */
        let purchaseQty = 1;
        if (typeof window.resolveGiftRowQty === 'function') {
            purchaseQty = window.resolveGiftRowQty();
        }
        const giftQty = purchaseQty === 3 ? 4 : purchaseQty;

        /* Always populate note with qty */
        updateFreeGiftNote(title, giftQty);
    }

    /*
    ==================================
    Restore Saved Selection
    ==================================
    */

    const savedVariant = localStorage.getItem('selectedFreeGiftVariant');

    if (savedVariant) {
        const savedInput = document.querySelector(
            `input[name="free_gift_variant"][value="${savedVariant}"]`
        );
        if (savedInput) {
            savedInput.checked = true;
        }
    }

    /*
    ==================================
    Variant Selection
    ==================================
    */

    document
        .querySelectorAll('input[name="free_gift_variant"]')
        .forEach(input => {
            input.addEventListener('change', updateWidget);
        });

    /*
    ==================================
    Confirm Button
    ==================================
    */

    if (confirmBtn) {

        confirmBtn.addEventListener('click', () => {

            const currentSelection = getCheckedVariantValue();
            const selectionChanged = currentSelection !== selectionOnOpen;

            userHasSelected = true;
            updateWidget();
            closeModal();

            // Only celebrate if they actually picked something new
            if (selectionChanged && currentSelection !== null) {
                launchFireworks(confirmBtn);
            }

        });

    } else {

        updateWidget();

    }

    /*
    ==================================
    Single Gift Product
    ==================================
    */

    const variants = document.querySelectorAll(
        'input[name="free_gift_variant"]'
    );

    if (variants.length === 1) {
    variants[0].checked = true;
    userHasSelected = true;
    updateWidget();

        /* Single-gift products have nothing for the customer to choose,
        so the rotating orbit label shouldn't show the product title —
        show a generic "FREE GIFT" label instead. */
        if (orbitLabel) {
            orbitLabel.textContent = 'FREE GIFT ✦ FREE GIFT ✦ FREE GIFT ✦ ';
        }
    }

    /*
    ==================================
    Initialize Widget
    ==================================
    */

    updateWidget();

    /*
    ==================================
    Realist Observer
    ==================================
    */

    /*
    Observe only the Realist modal/form container rather than the entire
    body. This prevents our mutation handler from firing on every DOM
    change caused by unrelated widgets (e.g. quick-add buttons for other
    products on the page), which was causing the main product quantity to
    be incremented instead of adding the clicked related product to cart.

    We find the Realist root lazily (it may not exist yet) and attach
    once it appears, then disconnect the body-level bootstrapper.
    */
    let realistRootObserver = null;

    function attachRealistObserver(root) {
        if (root.__giftRealistObserved) return;
        root.__giftRealistObserved = true;

        realistRootObserver = new MutationObserver(() => {

            const noteField = root.querySelector('#_rsi-field-note');

            if (!noteField) return;

            const wrapper = noteField.closest('._rsi-modal-fields-item');
            if (wrapper) {
                wrapper.style.display = 'none';
            }

            const selected = document.querySelector(
                'input[name="free_gift_variant"]:checked'
            );

            if (selected) {
                const purchaseQty = typeof window.resolveGiftRowQty === 'function'
                    ? window.resolveGiftRowQty()
                    : 1;
                const giftQty = purchaseQty === 3 ? 4 : purchaseQty;
                updateFreeGiftNote(selected.dataset.title, giftQty);
            }
        });

        realistRootObserver.observe(root, {
            childList: true,
            subtree: true
        });
    }

    /* Bootstrap: watch body only until Realist injects its container */
    const realistBootstrapObserver = new MutationObserver(() => {
        const realistRoot = (
            document.querySelector('#rsi-cod-form-quantity-offers-hook') ||
            document.querySelector('[class*="_rsi-"]')
        );
        if (realistRoot) {
            attachRealistObserver(realistRoot);
            realistBootstrapObserver.disconnect();
        }
    });

    realistBootstrapObserver.observe(document.body, {
        childList: true,
        subtree: true
    });

    /* Also handle the case where Realist is already in the DOM */
    (() => {
        const realistRoot = (
            document.querySelector('#rsi-cod-form-quantity-offers-hook') ||
            document.querySelector('[class*="_rsi-"]')
        );
        if (realistRoot) {
            attachRealistObserver(realistRoot);
            realistBootstrapObserver.disconnect();
        }
    })();


    /*
    ============================================================
    Realist Gift Line-Item Row
    ============================================================

    Injects a full native-looking line-item row for the free gift
    into BOTH Realist COD form appearances, then keeps it live as
    the customer changes quantity tier or gift variant.

    FORM A — quantity-offer picker  (._rsi-quantity-offers)
    ─────────────────────────────────────────────────────────
    Structure mirrors a real offer card:

        <div class="_rsi-quantity-offers-offer-container _gift-row-offer-container">
          <div class="_rsi-quantity-offers-offer">
            <div class="_rsi-modal-line-item-image-container">
              <img class="_rsi-modal-line-item-image" src="{giftImg}">
            </div>
            <div class="_rsi-quantity-offers-info">
              <div class="_rsi-quantity-offers-title">{giftLabel}</div>
            </div>
            <div class="_rsi-quantity-offers-prices">
              <div class="_rsi-quantity-offers-new-price">Ksh 0</div>
            </div>
          </div>
        </div>

    Appended after the last ._rsi-quantity-offers-offer-container.
    The qty bubble mirrors whichever tier is currently selected:
        Buy 1 → qty 1   Buy 2 → qty 2   Buy 3 → qty 4 (BOGO)
    It updates live whenever a tier card is clicked.

    FORM B — order-summary line-items  (._rsi-modal-line-items)
    ─────────────────────────────────────────────────────────────
    Structure mirrors a real line-item:

        <div class="_rsi-modal-line-item _gift-row-line-item">
          <div class="_rsi-modal-line-item-image-container">
            <img class="_rsi-modal-line-item-image" src="{giftImg}">
            <div class="_rsi-modal-line-item-quantity">{qty}</div>
          </div>
          <div class="_rsi-modal-line-item-info">
            <span class="_rsi-modal-line-item-title">{giftLabel}</span>
          </div>
          <div class="_rsi-modal-line-item-final-price">Ksh 0</div>
        </div>

    Appended after the last ._rsi-modal-line-item.

    GIFT LABEL
    ──────────
    Uses data-gift-product-name and data-gift-variant-title on the
    .free-gift-widget element (rendered from Liquid):

        Single-variant product → just the product name
        Multi-variant product  → "Product Name - Variant Title"

    CURRENCY
    ─────────
    Reads the currency symbol from the first ._rsi-quantity-offers-new-price
    or ._rsi-modal-line-item-final-price visible in the form.  Falls back
    to "Ksh" so the display is always correct.
    ============================================================
    */

    (function () {

        /* ── 1. Styles ───────────────────────────────────────────────── */

        if (!window.__giftRowStyleInjected) {
            window.__giftRowStyleInjected = true;

            const s = document.createElement('style');
            s.textContent = `
                /* Offer-card gift row — soft green FREE badge */
                ._gift-row-offer-container {
                    opacity: 0;
                    animation: _giftRowFadeIn .35s ease .05s forwards;
                }

                /* Line-item gift row */
                ._gift-row-line-item {
                    opacity: 0;
                    animation: _giftRowFadeIn .35s ease .05s forwards;
                }

                @keyframes _giftRowFadeIn {
                    from { opacity: 0; transform: translateY(6px); }
                    to   { opacity: 1; transform: translateY(0);   }
                }

                /* "FREE" price label */
                ._gift-row-free-price {
                    color: #16a34a !important;
                    font-weight: 700 !important;
                }

                /* Quantity bubble update flash */
                ._gift-row-qty-flash {
                    animation: _giftQtyPop .3s cubic-bezier(.34,1.56,.64,1) both !important;
                }

                @keyframes _giftQtyPop {
                    0%   { transform: scale(1);   }
                    45%  { transform: scale(1.45); }
                    100% { transform: scale(1);   }
                }
            `;
            document.head.appendChild(s);
        }


        /* ── 2. Helpers ──────────────────────────────────────────────── */

        /*
        Build the display label for the gift row.
        Reads data-gift-product-name and data-gift-variant-title from the
        .free-gift-widget element, which Liquid should populate:

            <div class="free-gift-widget"
                 data-gift-product-name="{{ gift_product.title | escape }}"
                 data-gift-variant-title="{{ gift_variant.title | escape }}">

        For a single-variant product Shopify sets the variant title to
        "Default Title" — we suppress that so only the product name shows.
        */
        function resolveGiftLabel(giftQty) {

            const w = document.querySelector('.free-gift-widget');

            const checked = document.querySelector(
                'input[name="free_gift_variant"]:checked'
            );

            const productName = (
                (checked && checked.dataset.productName) ||
                (w && (w.dataset.giftProductName || w.dataset.giftProductTitle)) ||
                'Gift'
            );

            /*
            Pluralise the last word of the product name when qty > 1,
            unless it already ends with "s" (e.g. "Oils" stays "Oils").
                "Essential Oil"  + qty 2 → "Essential Oils"
                "Essential Oils" + qty 2 → "Essential Oils"  (no double-s)
            */
            function pluralise(name) {
                if (!giftQty || giftQty <= 1) return name;
                const words = name.split(' ');
                const last  = words[words.length - 1];
                if (last.toLowerCase().endsWith('s')) return name;
                words[words.length - 1] = last + 's';
                return words.join(' ');
            }

            if (checked && checked.dataset.title) {
                const varTitle = checked.dataset.title.trim();
                const isRedundant = !varTitle
                    || varTitle.toLowerCase() === 'default title'
                    || varTitle.toLowerCase() === productName.toLowerCase();
                if (!isRedundant) {
                    return 'Free ' + pluralise(productName) + ' - ' + varTitle;
                }
            }

            if (w && w.dataset.giftVariantTitle) {
                const vt = w.dataset.giftVariantTitle.trim();
                if (vt && vt.toLowerCase() !== 'default title') {
                    return 'Free ' + pluralise(productName) + ' - ' + vt;
                }
            }

            return 'Free ' + pluralise(productName);
        }

        function resolveGiftImageSrc() {
            const checked = document.querySelector(
                'input[name="free_gift_variant"]:checked'
            );
            if (checked && checked.dataset.image) return checked.dataset.image;

            const widgetImg = document.querySelector('.free-gift-widget__image');
            if (widgetImg) return widgetImg.src || widgetImg.dataset.defaultImage || '';
            return '';
        }

        /*
        Resolve the currently-selected purchase quantity from the Realist
        quantity-offer picker (Form A) OR Pumper Bundles.

        For the Realist picker we read the hidden inputs inside the
        currently-selected offer container:
            ._rsi-quantity-offers-selected  input[name*="item_quantity"]
        */
        function resolveQuantity() {

            /* ── Realist quantity-offer picker ── */
            const selectedOffer = document.querySelector(
                '._rsi-quantity-offers-selected input[name*="item_quantity"]'
            );
            if (selectedOffer) {
                const v = parseInt(selectedOffer.value, 10);
                if (!isNaN(v) && v > 0) return v;
            }

            /* ── Pumper Bundles radio ── */
            const pumperRadio = document.querySelector(
                '#pumper_bundle_svelte input[name="cb"]:checked,' +
                '[id*="pumper"] input[name="cb"]:checked,' +
                '[class*="pumper"] input[name="cb"]:checked'
            );
            if (pumperRadio) {
                const v = parseInt(pumperRadio.value, 10);
                if (!isNaN(v) && v > 0) return v;
            }

            const anyRadio = document.querySelector('input[name="cb"]:checked');
            if (anyRadio) {
                const v = parseInt(anyRadio.value, 10);
                if (!isNaN(v) && v > 0) return v;
            }

            const pumperQtyInput = document.querySelector(
                'input[id*="custom_quantity"][type="hidden"],' +
                'input[class*="prvw_custom_quantity"][type="hidden"]'
            );
            if (pumperQtyInput) {
                const v = parseInt(pumperQtyInput.value, 10);
                if (!isNaN(v) && v > 0) return v;
            }

            return 1;
        }

        /*
        Gift quantity follows the BOGO rule:
            buy 1 → 1 gift   buy 2 → 2 gifts   buy 3 → 4 gifts
        */
        function resolveGiftQty(purchaseQty) {
            if (purchaseQty === 3) return 4;
            return purchaseQty;
        }

        /*
        Detect the currency symbol / prefix used by this store by reading
        the first price label already in the form.
        */
        function detectCurrencyPrefix() {
            const priceEl = document.querySelector(
                '._rsi-quantity-offers-new-price, ._rsi-modal-line-item-final-price'
            );
            if (!priceEl) return 'Ksh';

            /* Text before the <span class="money"> child, or the full text
               if there is no such span */
            const span = priceEl.querySelector('.money');
            if (span) {
                return priceEl.textContent.replace(span.textContent, '').trim();
            }
            return 'Ksh';
        }


        /* ── 3. Form A — quantity-offer picker row ───────────────────── */

        /*
        Creates a new offer-card container that looks identical to the
        existing tier cards but shows the gift product.  It is NOT
        clickable (pointer-events: none) so the customer cannot accidentally
        "select" the gift tier.
        */
        function createOfferRow(imgSrc, label, giftQty, currencyPrefix) {

            const container = document.createElement('div');
            container.className =
                '_rsi-quantity-offers-offer-container _gift-row-offer-container';
            container.dataset.giftRow = 'true';
            /* Prevent clicks from toggling offer selection */
            container.style.pointerEvents = 'none';
            container.style.cursor        = 'default';
            container.style.background        = '#f2f2f2';

            const offer = document.createElement('div');
            offer.className = '_rsi-quantity-offers-offer';

            /* Image — wrapped with qty bubble matching Form B's style */
            const imgWrap = document.createElement('div');
            imgWrap.className = '_rsi-modal-line-item-image-container';
            const img = document.createElement('img');
            img.className = '_rsi-modal-line-item-image';
            img.style.cssText = 'background-color: white; padding: 5px;';
            img.src       = imgSrc;
            img.alt       = label;
            imgWrap.appendChild(img);

            /* Qty bubble — same element class as Form B's quantity pill */
            const qtyBubble = document.createElement('div');
            qtyBubble.className = '_rsi-modal-line-item-quantity';
            qtyBubble.style.cssText = 'left: 35px !important;';
            qtyBubble.textContent = String(giftQty);
            imgWrap.appendChild(qtyBubble);

            offer.appendChild(imgWrap);

            /* Info */
            const info = document.createElement('div');
            info.className = '_rsi-quantity-offers-info';
            const title = document.createElement('div');
            title.className = '_rsi-quantity-offers-title';
            title.textContent = label;
            info.appendChild(title);
            offer.appendChild(info);

            /* Price — always FREE */
            const prices = document.createElement('div');
            prices.className = '_rsi-quantity-offers-prices';
            const price = document.createElement('div');
            price.className = '_rsi-quantity-offers-new-price _gift-row-free-price';
            price.innerHTML = `${currencyPrefix} <span class="money">0</span>`;
            prices.appendChild(price);
            offer.appendChild(prices);

            container.appendChild(offer);

            return container;
        }

        /*
        Inject or refresh the gift row inside ._rsi-quantity-offers.
        Called once on first injection and again whenever qty or variant changes.
        */
        function renderOfferRow() {

            const offersRoot = document.querySelector('._rsi-quantity-offers');
            if (!offersRoot) return;

            const imgSrc         = resolveGiftImageSrc();
            const purchaseQty    = resolveQuantity();
            const giftQty        = resolveGiftQty(purchaseQty);
            const label          = resolveGiftLabel(giftQty);
            const currencyPrefix = detectCurrencyPrefix();

            let row = offersRoot.querySelector('[data-gift-row="true"]');

            if (!row) {
                /* First injection */
                row = createOfferRow(imgSrc, label, giftQty, currencyPrefix);
                offersRoot.appendChild(row);
                return;
            }

            /* Subsequent updates — refresh in-place */
            const imgEl     = row.querySelector('._rsi-modal-line-item-image');
            const titleEl   = row.querySelector('._rsi-quantity-offers-title');
            const qtyBubble = row.querySelector('._rsi-modal-line-item-quantity');

            if (imgEl && imgSrc && imgEl.src !== imgSrc) {
                imgEl.src = imgSrc;
            }
            if (titleEl && titleEl.textContent !== label) {
                titleEl.textContent = label;
            }
            if (qtyBubble) {
                const next = String(giftQty);
                if (qtyBubble.textContent !== next) {
                    qtyBubble.classList.remove('_gift-row-qty-flash');
                    void qtyBubble.offsetWidth;
                    qtyBubble.classList.add('_gift-row-qty-flash');
                    qtyBubble.textContent = next;
                }
            }
        }


        /* ── 4. Form B — order-summary line-item row ─────────────────── */

        function createLineItemRow(imgSrc, label, giftQty, currencyPrefix) {

            const row = document.createElement('div');
            row.className    = '_rsi-modal-line-item _gift-row-line-item';
            row.dataset.giftRow = 'true';

            /* Image + qty bubble */
            const imgWrap = document.createElement('div');
            imgWrap.className = '_rsi-modal-line-item-image-container';

            const img = document.createElement('img');
            img.className = '_rsi-modal-line-item-image';
            img.src       = imgSrc;
            img.alt       = label;
            imgWrap.appendChild(img);

            const qtyBubble = document.createElement('div');
            qtyBubble.className = '_rsi-modal-line-item-quantity';
            qtyBubble.textContent = String(giftQty);
            imgWrap.appendChild(qtyBubble);

            row.appendChild(imgWrap);

            /* Title */
            const info = document.createElement('div');
            info.className = '_rsi-modal-line-item-info';
            const titleEl = document.createElement('span');
            titleEl.className   = '_rsi-modal-line-item-title';
            titleEl.textContent = label;
            info.appendChild(titleEl);
            row.appendChild(info);

            /* Price */
            const priceEl = document.createElement('div');
            priceEl.className = '_rsi-modal-line-item-final-price _gift-row-free-price';
            priceEl.innerHTML = `${currencyPrefix} <span class="money">0</span>`;
            row.appendChild(priceEl);

            return row;
        }

        function renderLineItemRow() {

            const lineItemsRoot = document.querySelector('._rsi-modal-line-items');
            if (!lineItemsRoot) return;

            const imgSrc         = resolveGiftImageSrc();
            const purchaseQty    = resolveQuantity();
            const giftQty        = resolveGiftQty(purchaseQty);
            const label          = resolveGiftLabel(giftQty);
            const currencyPrefix = detectCurrencyPrefix();

            let row = lineItemsRoot.querySelector('[data-gift-row="true"]');

            if (!row) {
                /* First injection */
                row = createLineItemRow(imgSrc, label, giftQty, currencyPrefix);
                lineItemsRoot.appendChild(row);
                return;
            }

            /* Subsequent updates */
            const imgEl     = row.querySelector('._rsi-modal-line-item-image');
            const qtyBubble = row.querySelector('._rsi-modal-line-item-quantity');
            const titleEl   = row.querySelector('._rsi-modal-line-item-title');

            if (imgEl && imgSrc && imgEl.src !== imgSrc) {
                imgEl.src = imgSrc;
            }

            if (titleEl && titleEl.textContent !== label) {
                titleEl.textContent = label;
            }

            if (qtyBubble) {
                const next = String(giftQty);
                if (qtyBubble.textContent !== next) {
                    qtyBubble.classList.remove('_gift-row-qty-flash');
                    void qtyBubble.offsetWidth;
                    qtyBubble.classList.add('_gift-row-qty-flash');
                    qtyBubble.textContent = next;
                }
            }
        }


        /* ── 5. Combined refresh ─────────────────────────────────────── */

        window.resolveGiftRowQty = resolveQuantity;

        window.renderAllGiftRows = function () {
            renderOfferRow();
            renderLineItemRow();

            /* Keep the order note in sync with the current qty whenever
               the Realist form is open and the customer changes tiers.  */
            const selected = document.querySelector(
                'input[name="free_gift_variant"]:checked'
            );
            if (selected && selected.dataset.title) {
                const purchaseQty = resolveQuantity();
                const giftQty     = resolveGiftQty(purchaseQty);
                updateFreeGiftNote(selected.dataset.title, giftQty);
            }
        };


        /* ── 6. Quantity-offer picker click listener ─────────────────── */

        /*
        When the customer clicks a tier card in the Realist quantity-offer
        picker, Realist updates the ._rsi-quantity-offers-selected class and
        the hidden item_quantity input.  We delegate on the offers root so
        a single listener covers all tier cards, then wait one tick for
        Realist to finish its own update before re-reading the quantity.
        */
        function attachOfferPickerListener() {

            const offersRoot = document.querySelector('._rsi-quantity-offers');
            if (!offersRoot || offersRoot.__giftOfferListened) return;
            offersRoot.__giftOfferListened = true;

            offersRoot.addEventListener('click', (e) => {
                /* Ignore clicks on our own non-interactive gift row */
                if (e.target.closest('[data-gift-row="true"]')) return;
                setTimeout(window.renderAllGiftRows, 60);
            });

            /* Also watch attribute/class mutations for programmatic changes */
            new MutationObserver(() => {
                setTimeout(window.renderAllGiftRows, 60);
            }).observe(offersRoot, {
                attributes:      true,
                subtree:         true,
                attributeFilter: ['class', 'value']
            });
        }


        /* ── 7. Gift-variant radio changes ───────────────────────────── */

        document
            .querySelectorAll('input[name="free_gift_variant"]')
            .forEach(input => input.addEventListener('change', window.renderAllGiftRows));


        /* ── 8. MutationObserver — watch for Realist form injections ── */

        /*
        Realist injects its COD form asynchronously, and may re-inject it
        each time the customer opens the order form (e.g. when their cart
        already has products). We therefore keep this observer alive for
        the entire page lifetime instead of disconnecting after a timeout.
        */
        const giftRowObserver = new MutationObserver(() => {

            const hasOffers    = !!document.querySelector('._rsi-quantity-offers');
            const hasLineItems = !!document.querySelector('._rsi-modal-line-items');

            if (hasOffers || hasLineItems) {
                window.renderAllGiftRows();
                attachOfferPickerListener();
            }
        });

        giftRowObserver.observe(document.body, {
            childList: true,
            subtree:   true
        });


        /* ── 9. Initial render ───────────────────────────────────────── */

        window.renderAllGiftRows();
        attachOfferPickerListener();

    })();


    /*
    ==================================
    Variant Product Image Swap
    ==================================

    When the user clicks a gift variant inside the modal, we attempt
    to load a matching product image from the Shopify CDN.

    URL format:
        https://cdn.shopify.com/s/files/1/0984/9166/2642/files/Var_{slug}.png

    The slug is derived from the variant title by:
        1. Trimming whitespace
        2. Capitalising the first letter of each word
        3. Replacing spaces with underscores
        e.g. "lemon grass" → "Lemon_Grass"
             "vanilla"     → "Vanilla"

    If the image URL returns a valid response (HTTP 200) we swap the src
    of the currently-active product media image on the page.
    If the URL is invalid / 404 we silently do nothing — the original
    product image stays in place.

    Target selector: .product__media-item.is-active .product__media img
    ==================================
    */

    (function () {

        const CDN_BASE =
            'https://cdn.shopify.com/s/files/1/0984/9166/2642/files/';

        /*
        Read the product metafield value that forms the filename suffix.
        The Liquid template should render it into a data attribute on the
        widget element, e.g.:
            <div class="free-gift-widget" data-image-suffix="{{ product.metafields.custom.image_suffix | escape }}">

        Falls back to an empty string if the attribute is absent so the
        URL degrades to the old Var_{slug}.png format (backward-compatible).
        */
        function getImageSuffix() {
            const widget = document.querySelector('.free-gift-widget');
            return (widget && widget.dataset.imageSuffix)
                ? widget.dataset.imageSuffix.trim()
                : '';
        }

        /*
        Convert a variant title into the filename slug used in the CDN.
        Examples:
            "Vanilla"      → "Vanilla"
            "Lemon Grass"  → "Lemon_Grass"
            "eucalyptus"   → "Eucalyptus"
        */
        function titleToSlug(title) {
            return title
                .trim()
                .split(/\s+/)
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join('_');
        }

        /*
        Build the full CDN URL for a given variant title.
        Format: Var_{slug}.png            (no suffix / suffix is empty)
                Var_{slug}_{Suffix}.png   (suffix present)

        The suffix is capitalised to match the convention:
            metafield value "fire"  → "Fire"
            metafield value "Fire"  → "Fire"   (already correct)
        */
        function buildImageUrl(title) {
            const slug   = titleToSlug(title);
            const raw    = getImageSuffix();
            const suffix = raw
                ? raw.charAt(0).toUpperCase() + raw.slice(1)
                : '';
            const filename = suffix
                ? 'Var_' + slug + '_' + suffix + '.png'
                : 'Var_' + slug + '.png';
            return CDN_BASE + filename;
        }

        /*
        Return the currently-active product image element on the page,
        or null if the selector doesn't match anything.
        */
        function getActiveProductImage() {
            return document.querySelector(
                '.product__media-item.is-active .product__media img'
            );
        }

        /*
        Check whether an image URL is reachable by sending a lightweight
        HEAD request. Resolves true if HTTP 200, false for anything else
        (404, network error, etc.).
        */
        function imageExists(url) {
            return fetch(url, { method: 'HEAD' })
                .then(res => res.ok)
                .catch(() => false);
        }

        /*
        Main handler — called whenever a gift variant radio input changes.
        Reads the variant title from data-title, builds the CDN URL,
        validates it, and swaps the product image if valid.
        */
        function handleVariantImageSwap(input) {

            const title = input.dataset.title;

            if (!title) return;

            const url = buildImageUrl(title);

            imageExists(url).then(exists => {

                if (!exists) {
                    // No matching CDN image — leave the product image as-is
                    return;
                }

                const productImg = getActiveProductImage();

                if (!productImg) {
                    // Active product image element not found on this theme
                    return;
                }

                /*
                Swap the src. We also clear srcset so the browser doesn't
                override our change with a responsive-image variant.
                Store the original src/srcset so we can restore if needed.
                */
                if (!productImg.dataset.originalSrc) {
                    productImg.dataset.originalSrc   = productImg.src;
                    productImg.dataset.originalSrcset = productImg.srcset || '';
                }

                productImg.srcset = '';
                productImg.src    = url;

            });

        }

        /*
        Attach the swap handler to every gift variant radio input.
        We use 'change' so it fires as soon as the user clicks a card.
        */
        document
            .querySelectorAll('input[name="free_gift_variant"]')
            .forEach(input => {
                input.addEventListener('change', () => {
                    handleVariantImageSwap(input);
                });
            });

    })();


    /*
    ============================================================
    BUY-BUTTON GIFT BADGE
    ============================================================

    WHAT THIS DOES
    ──────────────
    Appends a "+ [gift image] [×N]" badge to EVERY Realist Buy-Now
    button on the page (class ._rsi-buy-now-button). Using a class
    selector rather than getElementById means all button instances —
    whether added by Realist or manually duplicated — receive the badge.

    VISUAL STRUCTURE (left → right inside the button)
    ──────────────────────────────────────────────────
        [tag SVG icon]  [Order Yours Today]  [+ 🎁  ×N]
         order: 1            order: 2            order: 3

    The Realist icon already carries order:1 via inline style.
    We set order:2 on the text <span> and order:3 on our badge so
    the sequence is always correct regardless of DOM insertion order.

    QUANTITY TRACKING — PUMPER BUNDLES ONLY
    ────────────────────────────────────────
    We deliberately ignore ALL standard Shopify quantity inputs
    (#quantity, [name="quantity"], .quantity__input) because those
    selectors accidentally match hidden cart-form fields whose value
    equals the number of items already in the cart — not the bundle
    size the customer is choosing right now.

    Instead we read ONLY from Pumper Bundles signals:

        1. An offer card with a selected-state class that also carries
           a data-quantity or data-qty attribute.
        2. The Pumper root element's own selected-qty / data-qty /
           data-quantity attribute (Pumper updates this programmatically).
        3. A hidden <input name="quantity"> scoped strictly inside a
           Pumper-owned container (id/class contains "pumper").

    If none of those signals exist, quantity defaults to 1 (no label).

    MULTIPLIER DISPLAY RULE
    ───────────────────────
        qty 1  → no label         (just the gift image)
        qty 2  → ×2
        qty 3  → ×4   ← BOGO: buy 3, receive 4 gifts total
        qty 4+ → ×{qty}

    IMAGE SOURCE PRIORITY
    ─────────────────────
        1. Checked gift-variant radio  data-image
        2. Floating widget image       .free-gift-widget__image src
        3. Widget image                data-default-image attribute

    ANIMATIONS
    ──────────
        badgeBounceIn  — badge springs in from the right on first inject
        badgeFlip      — gift image Y-axis flip when variant changes
        badgePop       — ×N label bounces when quantity changes
        badgePlusPulse — "+" icon pulses on every badge update
    ============================================================
    */

    (function () {

        /* ── 1. Inject keyframes + badge styles once ─────────────── */

        if (!window.__giftBadgeStylesInjected) {

            window.__giftBadgeStylesInjected = true;

            const style = document.createElement('style');

            style.textContent = `

                @keyframes badgeBounceIn {
                    0%   { opacity: 0; transform: translateX(18px) scale(.65); }
                    55%  { opacity: 1; transform: translateX(-5px)  scale(1.1);  }
                    75%  { transform: translateX(2px)  scale(.97);  }
                    100% { opacity: 1; transform: translateX(0)     scale(1);    }
                }

                @keyframes badgeFlip {
                    0%   { transform: rotateY(0deg)   scale(1);   }
                    40%  { transform: rotateY(90deg)  scale(.82); }
                    60%  { transform: rotateY(-90deg) scale(.82); }
                    100% { transform: rotateY(0deg)   scale(1);   }
                }

                @keyframes badgePop {
                    0%   { transform: translateY(0)    scale(1);   }
                    35%  { transform: translateY(-6px) scale(1.3); }
                    70%  { transform: translateY(1px)  scale(.94); }
                    100% { transform: translateY(0)    scale(1);   }
                }

                @keyframes badgePlusPulse {
                    0%   { opacity: .75; transform: scale(1);    }
                    40%  { opacity: .35; transform: scale(1.4);  }
                    100% { opacity: .75; transform: scale(1);    }
                }

                /*
                Wrapper — no background, no border, no padding.
                Purely a transparent flex row inside the button.
                */
                ._gift-badge {
                    display:     inline-flex;
                    align-items: center;
                    gap:         0;
                    margin-left: 10px !important;
                    animation:   badgeBounceIn .45s cubic-bezier(.34,1.56,.64,1) both;
                    flex-shrink: 0;
                    border: 1px solid white;
                    padding: 3px 6px;
                    border-radius: 11px;
                    background: #f2f2f2;
                }

                /* "+" SVG separator */
                ._gift-badge__plus {
                    display:     block;
                    flex-shrink: 0;
                    opacity:     .75;
                    margin-right: 0px;
                }

                /* Circular gift image — no border */
                ._gift-badge__img {
                    width:         25px;
                    height:        25px;
                    border-radius: 50%;
                    object-fit:    cover;
                    display:       block;
                    flex-shrink:   0;
                }

                /*
                Quantity multiplier — hidden by default, shown when qty > 1.
                Negative margin pulls it snug against the image.
                */
                ._gift-badge__qty {
                    font-size:   15px;
                    font-weight: 700;
                    color:       #444;
                    line-height: 1;
                    white-space: nowrap;
                    display:     none;
                    margin-left: -3px;
                }
            `;

            document.head.appendChild(style);
        }


        /* ── 2. Resolve gift image URL ───────────────────────────── */

        function resolveGiftImageSrc() {

            const checked = document.querySelector(
                'input[name="free_gift_variant"]:checked'
            );

            if (checked && checked.dataset.image) {
                return checked.dataset.image;
            }

            const widgetImg = document.querySelector('.free-gift-widget__image');

            if (widgetImg) {
                return widgetImg.src || widgetImg.dataset.defaultImage || '';
            }

            return '';
        }


        /* ── 3. Resolve quantity — Pumper Bundles ───────────────── */

        /*
        HOW PUMPER BUNDLES COMMUNICATES THE SELECTED TIER
        ───────────────────────────────────────────────────
        Pumper does NOT use data-quantity attributes or selected/active CSS
        classes on its tier cards.  Instead it uses:

          Primary signal — checked radio input
            <input type="radio" name="cb" value="2" checked>
            The value equals the tier number (1 = Buy 1, 2 = Buy 2, 3 = Buy 3).

          Fallback signal — hidden quantity field in the outer product form
            <input type="hidden" name="quantity" value="2">
            Pumper keeps this in sync with the selected tier.  It lives in
            the product form, NOT inside a pumper-scoped container, so we
            must identify it by finding the one that lives OUTSIDE the Pumper
            widget itself (its value > 0 and changes when tiers change).

        We use the radio as the primary source because it is always present
        and its checked state is authoritative.  The hidden input is a
        reliable fallback when radios are not found.
        */
        function resolveQuantity() {

            /* ── Signal 1: Pumper tier radio — input[name="cb"]:checked ─
               Pumper renders one radio per tier with value = tier number
               (1, 2, 3 …).  The checked radio's value IS the quantity.   */
            const pumperRadio = document.querySelector(
                '#pumper_bundle_svelte input[name="cb"]:checked,' +
                '[id*="pumper"] input[name="cb"]:checked,' +
                '[class*="pumper"] input[name="cb"]:checked'
            );

            if (pumperRadio) {
                const v = parseInt(pumperRadio.value, 10);
                if (!isNaN(v) && v > 0) return v;
            }

            /* ── Signal 2: any checked radio named "cb" on the page
               (broader fallback in case the pumper container selector
               doesn't match the exact DOM structure in this theme)       */
            const anyRadio = document.querySelector('input[name="cb"]:checked');
            if (anyRadio) {
                const v = parseInt(anyRadio.value, 10);
                if (!isNaN(v) && v > 0) return v;
            }

            /* ── Signal 3: hidden quantity input synced by Pumper.
               We locate it by reading the hidden input whose id contains
               "custom_quantity" (Pumper's own naming convention), which
               avoids matching the standard Shopify cart form quantity.   */
            const pumperQtyInput = document.querySelector(
                'input[id*="custom_quantity"][type="hidden"],' + 
                'input[class*="prvw_custom_quantity"][type="hidden"]'
            );

            if (pumperQtyInput) {
                const v = parseInt(pumperQtyInput.value, 10);
                if (!isNaN(v) && v > 0) return v;
            }

            /* ── Signal 4: data-quantity / data-qty attributes with an
               active-state indicator (legacy / other bundle apps)        */
            for (const el of document.querySelectorAll('[data-quantity],[data-qty]')) {
                const cls = (el.className || '').toLowerCase();
                const isActive = (
                    cls.includes('selected') || cls.includes('active')   ||
                    cls.includes('checked')  || cls.includes('current')  ||
                    el.getAttribute('aria-selected') === 'true' ||
                    el.getAttribute('aria-checked')  === 'true' ||
                    el.getAttribute('data-selected') !== null
                );
                if (isActive) {
                    const v = parseInt(el.dataset.quantity || el.dataset.qty, 10);
                    if (!isNaN(v) && v > 0) return v;
                }
            }

            /* ── Default ── */
            return 1;
        }


        /* ── 4. Multiplier label from quantity ───────────────────── */

        function computeMultiplierLabel(qty) {
            if (qty <= 1)  return null;
            if (qty === 3) return 'x4';   /* BOGO: buy 3, get 4 gifts */
            return `x${qty}`;
        }


        /* ── 5. Build "+" SVG element ────────────────────────────── */

        function buildPlusSvg() {

            const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            svg.setAttribute('width',   '10');
            svg.setAttribute('height',  '14');
            svg.setAttribute('viewBox', '0 0 14 14');
            svg.setAttribute('fill',    'none');
            svg.classList.add('_gift-badge__plus');

            const h = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            h.setAttribute('x', '0'); h.setAttribute('y', '5.75');
            h.setAttribute('width', '14'); h.setAttribute('height', '2.5');
            h.setAttribute('rx', '1.25'); h.setAttribute('fill', 'black');

            const v = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            v.setAttribute('x', '5.75'); v.setAttribute('y', '0');
            v.setAttribute('width', '2.5'); v.setAttribute('height', '14');
            v.setAttribute('rx', '1.25'); v.setAttribute('fill', 'black');

            svg.appendChild(h);
            svg.appendChild(v);

            return svg;
        }


        /* ── 6. Create badge element ─────────────────────────────── */

        function createBadge(imgSrc, qtyLabel) {

            const badge = document.createElement('span');
            badge.className = '_gift-badge';

            badge.appendChild(buildPlusSvg());

            const img = document.createElement('img');
            img.className = '_gift-badge__img';
            img.src       = imgSrc;
            img.alt       = 'Free gift';
            img.draggable = false;
            badge.appendChild(img);

            const qty = document.createElement('span');
            qty.className = '_gift-badge__qty';
            badge.appendChild(qty);
            applyQtyLabel(qty, qtyLabel);

            return badge;
        }


        /* ── 7. Show / hide / animate the quantity label ─────────── */

        function applyQtyLabel(qtyEl, label) {
            if (label) {
                /*
                inline-flex keeps the span in the flex row of ._gift-badge.
                'block' collapses or wraps unexpectedly inside flex containers.
                */
                qtyEl.style.display    = 'inline-flex';
                qtyEl.style.alignItems = 'center';
                qtyEl.textContent      = label;
            } else {
                qtyEl.style.display = 'none';
                qtyEl.textContent   = '';
            }
        }


        /* ── 8. Fix child order inside a button ──────────────────── */

        /*
        Realist's tag SVG already has order:1 from its own inline styles.
        We assign order:2 to the text span and order:3 to the badge so the
        visual sequence is always:  [icon]  [text]  [+ gift]
        */
        function ensureButtonChildOrder(btn) {
            const textSpan = btn.querySelector(
                'span:not(._gift-badge):not(._gift-badge__qty)'
            );
            if (textSpan) textSpan.style.order = '2';

            const badge = btn.querySelector('._gift-badge');
            if (badge)    badge.style.order    = '3';
        }


        /* ── 9. Render / refresh badge on ONE button ─────────────── */

        function renderBadgeOnButton(btn) {

            const imgSrc   = resolveGiftImageSrc();
            const qty      = resolveQuantity();
            const qtyLabel = computeMultiplierLabel(qty);

            let badge = btn.querySelector('._gift-badge');

            if (!badge) {
                /* First render — inject */
                badge = createBadge(imgSrc, qtyLabel);
                btn.appendChild(badge);
                ensureButtonChildOrder(btn);
                return;
            }

            /* Subsequent renders — update in-place with animations */

            const plusEl = badge.querySelector('._gift-badge__plus');
            const imgEl  = badge.querySelector('._gift-badge__img');
            const qtyEl  = badge.querySelector('._gift-badge__qty');

            /* "+" pulse on every update */
            if (plusEl) {
                plusEl.style.animation = 'none';
                void plusEl.offsetWidth;
                plusEl.style.animation = 'badgePlusPulse .4s ease both';
            }

            /* Flip image if src changed */
            if (imgEl && imgSrc && imgEl.src !== imgSrc) {
                imgEl.style.animation = 'none';
                void imgEl.offsetWidth;
                imgEl.style.animation = 'badgeFlip .4s ease both';
                imgEl.src = imgSrc;
            }

            /* Pop multiplier label if value changed */
            if (qtyEl) {
                const next = qtyLabel || '';
                if (qtyEl.textContent !== next) {
                    qtyEl.style.animation = 'none';
                    void qtyEl.offsetWidth;
                    qtyEl.style.animation = 'badgePop .35s cubic-bezier(.34,1.56,.64,1) both';
                    applyQtyLabel(qtyEl, qtyLabel);
                }
            }
        }


        /* ── 10. Render badge on ALL buttons ─────────────────────── */

        /*
        Targets every element with class ._rsi-buy-now-button so that
        manually-added duplicates of the button are included automatically.
        */
        function renderAllBadges() {
            document
                .querySelectorAll('.product-form__buttons ._rsi-buy-now-button')
                .forEach(btn => renderBadgeOnButto(btn));
        }


        /* ── 11. Watch gift-variant radio changes ────────────────── */

        document
            .querySelectorAll('input[name="free_gift_variant"]')
            .forEach(input => input.addEventListener('change', renderAllBadges));


        /* ── 12. Watch Pumper Bundles for quantity changes ────────── */

        /*
        Strategy A — click delegation with 80 ms delay.
            Pumper intercepts the click and updates its state before
            our handler runs, so we wait a moment before reading.

        Strategy B — MutationObserver on the Pumper root.
            Catches programmatic attribute / class mutations that don't
            produce a native click event (e.g. Pumper JS auto-selecting
            the default tier on load).
        */
        function attachPumperListeners() {

            const pumperContainer = (
                document.querySelector('#pumper_bundle_svelte') ||
                document.querySelector('#svelte-bundle-widget') ||
                document.querySelector('pumper-bundles')           ||
                document.querySelector('[data-pumper-root]')       ||
                document.querySelector('[class*="pumper-bundle"]') ||
                document.querySelector('[class*="pumper"]')
            );

            if (!pumperContainer || pumperContainer.__giftPumperListened) return;

            pumperContainer.__giftPumperListened = true;

            /* A: click delegation — Pumper updates radio state on click,
               so we wait a tick before reading the new checked value     */
            pumperContainer.addEventListener('click', () => {
                setTimeout(renderAllBadges, 80);
            });

            /* B: MutationObserver — also watches childList/subtree to catch
               re-renders, and 'style' since Pumper changes border/background
               inline on the selected label rather than adding a class.      */
            new MutationObserver(renderAllBadges).observe(pumperContainer, {
                attributes:      true,
                subtree:         true,
                childList:       true,
                attributeFilter: [
                    'class', 'style', 'checked', 'value',
                    'data-quantity', 'data-qty', 'selected-qty', 'aria-selected'
                ]
            });

            /* C: Also watch the hidden quantity input Pumper keeps in sync  */
            const outerQtyInput = document.querySelector(
                'input[id*="custom_quantity"][type="hidden"],' +
                'input[class*="prvw_custom_quantity"][type="hidden"]'
            );
            if (outerQtyInput && !outerQtyInput.__giftQtyListened) {
                outerQtyInput.__giftQtyListened = true;
                new MutationObserver(renderAllBadges).observe(outerQtyInput, {
                    attributes:      true,
                    attributeFilter: ['value']
                });
                outerQtyInput.addEventListener('change', renderAllBadges);
                outerQtyInput.addEventListener('input',  renderAllBadges);
            }
        }

        attachPumperListeners();


        /* ── 13. MutationObserver — waits for buttons to appear ───── */

        /*
        Realist injects its buttons asynchronously. We observe the body
        until all ._rsi-buy-now-button elements are present, re-run
        renderAllBadges and attachPumperListeners each time the DOM
        changes, then disconnect once everything is stable.
        */
        let domStableTimer = null;

        const badgeObserver = new MutationObserver(() => {

            const buttons = document.querySelectorAll('.product-form__buttons ._rsi-buy-now-button');

            if (buttons.length > 0) {
                renderAllBadges();
                attachPumperListeners();
            }

            /*
            Disconnect after the DOM has been quiet for 3 seconds.
            This gives Realist plenty of time to finish injecting all
            its elements without us observing forever.
            */
            clearTimeout(domStableTimer);
            domStableTimer = setTimeout(() => {
                badgeObserver.disconnect();
            }, 3000);
        });

        badgeObserver.observe(document.body, {
            childList: true,
            subtree:   true
        });


        /* ── 14. Initial render ───────────────────────────────────── */

        renderAllBadges();

    })();

});